"use client";

import React from "react";
import Link from "next/link";
import { BlurFade } from "@/components/ui/blur-fade";
import { ChevronRight } from "lucide-react";

interface Breadcrumb {
  label: string;
  href?: string;
}

interface HeroSimpleProps {
  title: string;
  subtitle?: string;
  breadcrumbs?: Breadcrumb[];
}

const HeroSimple = ({ title, subtitle, breadcrumbs }: HeroSimpleProps) => {
  return (
    <section className="py-24 md:py-32 px-6 bg-secondary">
      <div className="container max-w-4xl mx-auto text-center">
        {/* Breadcrumbs */}
        {breadcrumbs && breadcrumbs.length > 0 && (
          <BlurFade delay={0.05}>
            <nav
              className="flex items-center justify-center gap-1.5 text-sm text-foreground/50 mb-8"
              aria-label="Breadcrumb"
            >
              {breadcrumbs.map((crumb, i) => (
                <React.Fragment key={i}>
                  {i > 0 && <ChevronRight size={14} className="text-foreground/30" />}
                  {crumb.href ? (
                    <Link
                      href={crumb.href}
                      className="hover:text-foreground/80 transition-colors"
                    >
                      {crumb.label}
                    </Link>
                  ) : (
                    <span className="text-foreground/70 font-medium">{crumb.label}</span>
                  )}
                </React.Fragment>
              ))}
            </nav>
          </BlurFade>
        )}

        {/* Title */}
        <BlurFade delay={0.1}>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-foreground leading-[1.1]">
            {title}
          </h1>
        </BlurFade>

        {/* Subtitle */}
        {subtitle && (
          <BlurFade delay={0.2}>
            <p className="mt-6 text-lg md:text-xl text-foreground/60 max-w-2xl mx-auto leading-relaxed">
              {subtitle}
            </p>
          </BlurFade>
        )}
      </div>
    </section>
  );
};

export default HeroSimple;
